import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {Grid} from "@mui/material";
import {grey300} from "../../../../../../assets/jss/main";
import Badge from "../../../../../../components/Badge";
import {FormattedMessage} from "react-intl";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import CustomButton from "../../../../../../components/CustomButton";
import {LogsContext} from "../../../logsContext";
import ArrowDownIcon from "../../../../../../components/icons/ArrowDownIcon";

ShipmentItem.propTypes = {
    shipment: PropTypes.object.isRequired
};

function ShipmentItem({shipment}) {
    const {seeItemLog, itemId, selectedItemIdentifier, selectedItemBarcode} = useContext(LogsContext)

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ArrowDownIcon/>}>
                <Grid container flexWrap={"nowrap"}>
                    <Grid container flexWrap={"nowrap"} alignItems={"center"} gap={1}>
                        {shipment.trackingNumber && (
                            <Grid item>
                                {shipment.trackingNumber}
                            </Grid>
                        )}

                        <Grid item>
                            {shipment.wmsBarcode}
                        </Grid>

                        <Grid item>
                            {shipment.orderCustomer}
                        </Grid>

                        <Badge color={"default"} rounded isBold>
                            <FormattedMessage id={`wms.logs.shipmentItems.badge.status.${shipment.status}`}/>
                        </Badge>
                    </Grid>
                </Grid>
            </AccordionSummary>
            <AccordionDetails sx={{backgroundColor: grey300, padding: 0}}>
                <Grid container sx={{padding: "8px"}} direction={"column"}>

                    <Grid container flexWrap={'nowrap'} alignItems={"center"}>
                        <span><FormattedMessage id={"wms.logs.shipmentItems.orderId.label"}/></span>
                        <Badge color={"default"} rounded isBold>
                            {shipment.orderId}
                        </Badge>
                    </Grid>

                    <Grid container flexWrap={'nowrap'} alignItems={"center"}>
                        <span><FormattedMessage id={"wms.logs.shipmentItems.weight.label"}/></span>
                        <Badge color={"default"} rounded isBold>
                            {shipment.weight > 0 ? shipment.weight : "N/A"}
                        </Badge>
                    </Grid>

                    <Grid container flexWrap={'nowrap'} alignItems={"center"}>
                        <span><FormattedMessage id={"wms.logs.shipmentItems.address.label"}/></span>
                        <Badge color={"default"} rounded isBold>
                            {shipment.address}, {shipment.city}, {shipment.country}
                        </Badge>
                    </Grid>

                    <Grid container flexWrap={'nowrap'} alignItems={"center"}>
                        <span><FormattedMessage id={"wms.logs.shipmentItems.shippingMethod.label"}/></span>
                        <Badge color={"default"} rounded isBold>
                            {shipment.shippingMethod}
                        </Badge>
                    </Grid>

                    <Grid container flexWrap={'nowrap'} alignItems={"center"}>
                        <span><FormattedMessage id={"wms.logs.shipmentItems.itemCount.label"}/></span>
                        <Badge color={"default"} rounded isBold>
                            {shipment.itemCount}
                        </Badge>
                    </Grid>

                    <Grid container flexWrap={'nowrap'} alignItems={"center"}>
                        <span><FormattedMessage id={"wms.logs.shipmentItems.isMulti.label"}/></span>
                        <Badge color={shipment.isMulti ? "online" : "default"} rounded isBold>
                            <FormattedMessage id={shipment.isMulti ? "wms.logs.shipmentItems.isMulti.yes" : "wms.logs.shipmentItems.isMulti.no"}/>
                        </Badge>
                    </Grid>

                    {shipment.currentContainer && (
                        <Grid container flexWrap={'nowrap'} alignItems={"center"}>
                            <span><FormattedMessage id={"wms.logs.shipmentItems.currentContainer.label"}/></span>
                            <Badge color={"default"} rounded isBold>
                                {shipment.currentContainer.fullName}
                            </Badge>
                            <Badge color={"online"} rounded isBold>
                                <FormattedMessage id={`wms.container.type.name.${shipment.currentContainer.type}`}/>
                            </Badge>
                        </Grid>
                    )}

                    {shipment.error && (
                        <Grid container>
                            <Badge color={"error"} rounded isBold>
                                {shipment.error}
                            </Badge>
                        </Grid>
                    )}

                    <Grid item sx={{marginTop: "8px"}}>
                        <CustomButton fullWidth onClick={() => {
                            itemId.current = shipment.id
                            selectedItemIdentifier.current = shipment.trackingNumber ?? shipment.wmsBarcode
                            selectedItemBarcode.current = shipment.wmsBarcode
                            seeItemLog()
                        }}>
                            <FormattedMessage id={"wms.logs.itemList.seeTheLogs"}/>
                        </CustomButton>
                    </Grid>

                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default ShipmentItem;